import React from 'react';
import ResponsiveLazyImage from '../atoms/ResponsiveLazyImage';

const MethodologySection = ({
  id = 'how-it-works',
  title = 'How footyLab works',
  subtitle = 'Play, analyze, and create — soccer first, then the data from that game.',
  steps = [],
  showFounderQuote = false,
  className = '',
}) => {
  return (
    <section
      id={id}
      className={`py-16 md:py-20 bg-white scroll-mt-24 ${className}`.trim()}
      aria-labelledby={`${id}-heading`}
    >
      <div className="dr-container">
        <h2
          id={`${id}-heading`}
          tabIndex={-1}
          className="text-3xl md:text-4xl font-black text-center mb-4 focus:outline-none"
        >
          {title}
        </h2>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">{subtitle}</p>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 list-none p-0 m-0">
          {steps.map((step, index) => (
            <li
              key={step.id}
              className="relative bg-gray-50 rounded-2xl p-8 border border-gray-200 border-l-4 border-l-yellow transition duration-150 hover:shadow-md hover:-translate-y-px motion-reduce:transform-none motion-reduce:transition-none"
            >
              {index < steps.length - 1 && (
                <span
                  className="hidden md:block absolute top-1/2 -right-4 w-8 border-t-2 border-yellow"
                  aria-hidden="true"
                />
              )}
              {step.image && (
                <figure className="m-0 mb-4">
                  <ResponsiveLazyImage
                    originalSrc={step.image}
                    alt={step.alt}
                    width={800}
                    height={600}
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover object-center rounded-lg"
                  />
                  <figcaption className="mt-2 text-sm text-gray-500">{step.caption}</figcaption>
                </figure>
              )}
              <p className="text-sm font-bold uppercase tracking-wide text-navy mb-1">
                {step.phrase}
              </p>
              <h3 className="text-2xl font-bold mb-3 text-navy">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </li>
          ))}
        </ol>

        {showFounderQuote && (
          <div className="mt-12 text-center">
            <p className="text-lg font-medium text-gray-700 max-w-3xl mx-auto">
              &ldquo;I watched a middle-schooler transform from &apos;I hate math&apos; to
              &apos;I love data science&apos; by analyzing her own soccer stats.&rdquo;
            </p>
            <p className="text-sm text-gray-500 mt-2">- Gus Alvarez-Suchini, Founder</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default MethodologySection;
